import { createSlice } from '@reduxjs/toolkit';
import { IWellWaterSystemsMetrics } from '../../../types';
import { fetchWellWaterSystemMetricsAsync,fetchWellWaterSystemMetricsAsyncBuilder } from './asyncRequests'


export interface WellWaterSystemsMetricsInitialState {
  data: IWellWaterSystemsMetrics;
  loading: boolean;
  error: string;
  success: boolean;
}

const initialState: WellWaterSystemsMetricsInitialState = {
  data: [],
  loading: false,
  error: '',
  success: false,
}

export const WellWaterSystemsMetricsSlice = createSlice({
  name: 'wellWaterSystemMetricsSlice',
  initialState,
  reducers: {
    resetWellWaterSystemMetricsData: (state) => {
      state.data = initialState.data
    }
  },
  extraReducers: (builder) => {
    fetchWellWaterSystemMetricsAsyncBuilder(builder);
  },
})

export const WellWaterSystemsMetricsActions = {
  ...WellWaterSystemsMetricsSlice.actions,
  fetchWellWaterSystemMetricsAsync,
}

export const WellWaterSystemsMetricsReducer = WellWaterSystemsMetricsSlice.reducer;
